import Vue from "vue";
import App from "@/views/app/App.vue";
import router from "@/router";
import VueDraggableResizable from "vue-draggable-resizable";
import "../node_modules/vue-draggable-resizable/dist/VueDraggableResizable.css";

import VueI18n from "vue-i18n";
import ja from "@/language/ja.json";
import en from "@/language/en.json";
import ElementUI from "element-ui";
import localeJa from "element-ui/lib/locale/lang/ja";
import localeEn from "element-ui/lib/locale/lang/en";
import "../node_modules/element-ui/lib/theme-chalk/index.css";
import "../node_modules/element-ui/lib/theme-chalk/display.css";
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";

import Amplify from "aws-amplify";
import appSyncConfig from "./services/aws_exports/aws_exports";
import initialState from "./store/initial_state";
import "./registerServiceWorker";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(fas, far);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Amplify.configure(appSyncConfig);

Vue.config.productionTip = false;

Vue.component("VueDraggableResizable", VueDraggableResizable);

Vue.use(VueI18n);
const messages = {
  ja: Object.assign(ja, localeJa),
  en: Object.assign(en, localeEn),
}
const i18n = new VueI18n({
  locale: initialState.language,
  fallbackLocale: "en",
  messages,
});
const translate = (key: string) => {
  if (!key) {
    return "";
  }
  return i18n.t(key);
};
export { i18n, translate };

Vue.use(ElementUI, {
  i18n: (key: string, value: string) => i18n.t(key, value),
  CollapseTransition,
})

new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
  i18n,
  created() {
    localStorage.setItem("initialState", JSON.stringify(initialState));
  },
});
